<template>
    <div class="data-table-wrapper">
        <div class="data-table-overflow-wrapper">
            <table class="data-table">
                <!-- Header -->
                <TableHeader v-if="$slots.header || columnHeaders.length">
                    <template v-if="$slots.header">
                        <slot name="header" />
                    </template>
                    <template v-else>
                        <TableRow>
                            <TableHeaderCell
                                v-for="(header, index) in columnHeaders"
                                :key="index"
                                :align="typeof header === 'object' ? header.align : headerAlign"
                            >
                                {{ typeof header === "object" ? header.name : header }}
                            </TableHeaderCell>
                        </TableRow>
                    </template>
                </TableHeader>

                <!-- Body -->
                <TableBody v-if="$slots.default">
                    <slot />
                </TableBody>

                <!-- Fallback -->
                <slot v-if="!$slots.header && !$slots.default && !columnHeaders.length" />
            </table>
        </div>

        <slot name="footer" />
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import TableHeader from "./TableHeader.vue";
import TableBody from "./TableBody.vue";
import TableHeaderCell from "./TableHeaderCell.vue";
import TableRow from "./TableRow.vue";
import type { ColumnHeader } from "@/types/tables";
import type { Align } from "@/types/alignment";

export default defineComponent({
    components: {
        TableHeader,
        TableBody,
        TableHeaderCell,
        TableRow,
    },
    name: "DataTable",
    props: {
        hasOverflow: {
            type: Boolean,
            default: true,
        },
        columnHeaders: {
            type: Array as PropType<ColumnHeader[]>,
            default: () => [],
        },
        headerAlign: {
            type: String as PropType<Align>,
            default: "left",
        },
    },
});
</script>

<style>
@import "@/style/data-tables.css";
</style>
